import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Grid,
  Typography,
  Box,
  Paper,
  Divider,
  MenuItem,
  List,
  ListItem,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import Select from "react-select";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import Headroom from "react-headroom";
import DialogTitle from "@mui/material/DialogTitle";
import { ArrowBackOutlined } from "@mui/icons-material";
const EligibilityCheck = (props) => {
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const [payer, setPayer] = useState({
    value: "AARP",
    label: "AARP",
  });
  const [provider, setProvider] = useState("");
  const [benefitType, setBenefitType] = useState(null);
  const [procedureCode, setProcedureCode] = useState("");
  const [lastName, setLastName] = useState(props.LastName);
  const [firstName, setFirstName] = useState(props.firstName);
  const [relationship, setRelationship] = useState(props.SubLastName ? "G8" :"18" );
  const [policyNumber, setPolicyNumber] = useState(props.memberId);
  const [dob, setDob] = React.useState(moment(props.Dob).format("YYYY-MM-DD"));
  const [dos, setDos] = useState("");

  const [Insurance, setInsurance] = useState([]);
  const [selectedInsurance, setSelectedInsurance] = useState(null);

  // useEffect(() => {
  //   axios
  //     .get(`${process.env.REACT_APP_API_URL}/Insurances/getInsurance`, {
  //       headers,
  //     })

  //     .then((response) => {
  //       var prov = [];
  //       response.forEach((field) => {
  //         prov.push({
  //           label: field.name,
  //           value: field.payerId,
  //         });
  //       });
  //       setInsurance(prov);
  //     })
  //     .catch((error) => {});
  // }, []);

  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedPayer, setSelectedPayer] = useState(null);

  const handleSearch = async (value) => {
    setInputValue(value);
    if (!value) {
      setOptions([]);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Insurances/getInsuranceByName?Name=${value}`,
        { headers }
      );

      // format API response
      const formatted = response.map((item) => ({
        label: item.name,
        value: item.payerid,
      }));

      setOptions(formatted);
    } catch (error) {
      console.error("Error fetching insurance:", error);
      setOptions([]);
    }
    setLoading(false);
  };
  const highlightMatch = (text, query) => {
    if (!query) return text;
    const parts = text.split(new RegExp(`(${query})`, "gi"));
    return parts.map((part, i) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <span
          key={i}
          style={{
            backgroundColor: "#fff176", // highlight color
            borderRadius: 2,
            padding: "0 2px",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };
  const handleSelect = (option) => {
    setSelectedInsurance(option);
    setSelectedPayer(option);
    setInputValue(option.label || option.value);
    setOptions([]);
    setErrors((prev) => ({
      ...prev,
      insurance: "",
    }));
  };
  const [FormLoading, setFormLoading] = useState(false);

  const validateForm = () => {
    let tempErrors = {};

    // Insurance validation
    if (!selectedPayer) {
      tempErrors.insurance = "Insurance Company is required";
    } else if (!selectedPayer.value) {
      tempErrors.insurance =
        "Selected insurance does not have a valid Payer ID";
    }

    // Provider validation
    if (!selectedProvider) {
      tempErrors.provider = "Provider is required";
    }
    if (!benefitType) {
      tempErrors.benefitTypee = "Benefit is required";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const [ProviderOption, setProviderOption] = useState([]);
  const [ProcedureOption, setProcedureOption] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const practiceID = localStorage.getItem("default_paractice");
  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/Providers/getProviders?practiceId=${practiceID}`,
        {
          headers,
        }
      )
      .then((response) => {
        var prov = [];
        response.forEach((field) => {
          prov.push({
            label: `${field.lastName},${field.firstName}`,
            value: field.nPI,
            taxId: field.taxId,
          });
        });
        setProviderOption(prov);
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Procedures/Procedures`, {
        headers,
      })
      .then((response) => {
        var prov = [];
        response.forEach((field) => {
          prov.push({
            label: field.code,
            value: field.id,
          });
        });
        setProcedureOption(prov);
      })
      .catch((error) => {});
  }, []);
  const eligibilityInfo = [
    { value: "30", label: "Health Benefit Plan Coverage " },
    { value: "85", label: "AIDS " },
    { value: "84", label: "Abortion " },
    { value: "64", label: "Acupuncture " },
    { value: "28", label: "Adjunctive Dental Services " },
    { value: "57", label: "Air Transportation " },
    { value: "AJ", label: "Alcoholism " },
    { value: "GY", label: "Allergy " },
    { value: "79", label: "Allergy Testing " },
    { value: "15", label: "Alternate Method Dialysis " },
    { value: "13", label: "Ambulatory Service Center Facility " },
    { value: "7", label: "Anesthesia " },
    { value: "97", label: "Anesthesiologist " },
    { value: "71", label: "Audiology Exam " },
    { value: "10", label: "Blood Charges " },
    { value: "91", label: "Brand Name Prescription Drug " },
    { value: "B2", label: "Brand Name Prescription Drug - Formulary " },
    { value: "B3", label: "Brand Name Prescription Drug - Non-Formulary " },
    { value: "B1", label: "Burn Care " },
    { value: "58", label: "Cabulance " },
    { value: "87", label: "Cancer " },
    { value: "BL", label: "Cardiac " },
    { value: "BG", label: "Cardiac Rehabilitation " },
    { value: "CQ", label: "Case Management " },
    { value: "78", label: "Chemotherapy " },
    { value: "33", label: "Chiropractic " },
    { value: "34", label: "Chiropractic Office Visits " },
    { value: "16", label: "Chronic Renal Disease (CRD) Equipment " },
    { value: "BD", label: "Cognitive Therapy " },
    { value: "3", label: "Consultation " },
    { value: "C1", label: "Coronary Care " },
    { value: "BC", label: "Day Care (Psychiatric) " },
    { value: "37", label: "Dental Accident " },
    { value: "35", label: "Dental Care " },
    { value: "36", label: "Dental Crowns " },
    { value: "DG", label: "Dermatology " },
    { value: "DS", label: "Diabetic Supplies " },
    { value: "23", label: "Diagnostic Dental " },
    { value: "5", label: "Diagnostic Lab " },
    { value: "73", label: "Diagnostic Medical " },
    { value: "4", label: "Diagnostic X-Ray " },
    { value: "76", label: "Dialysis " },
    { value: "63", label: "Donor Procedures " },
    { value: "AK", label: "Drug Addiction " },
    { value: "DM", label: "Durable Medical Equipment " },
    { value: "12", label: "Durable Medical Equipment Purchase " },
    { value: "18", label: "Durable Medical Equipment Rental " },
    { value: "86", label: "Emergency Services " },
    { value: "BP", label: "Endocrine " },
    { value: "26", label: "Endodontics " },
    { value: "AR", label: "Experimental Drug Therapy " },
    { value: "BR", label: "Eye " },
    { value: "CP", label: "Eyewear and Eyewear Accessories " },
    { value: "82", label: "Family Planning " },
    { value: "CO", label: "Flu Vaccination " },
    { value: "AM", label: "Frames " },
    { value: "89", label: "Free Standing Prescription Drug " },
    { value: "BN", label: "Gastrointestinal " },
    { value: "60", label: "General Benefits " },
    { value: "92", label: "Generic Prescription Drug " },
    { value: "GF", label: "Generic Prescription Drug - Formulary " },
    { value: "GN", label: "Generic Prescription Drug - Non-Formulary " },
    { value: "BT", label: "Gynecological " },
    { value: "30", label: "Health Benefit Plan Coverage" },
    { value: "42", label: "Home Health Care " },
    { value: "43", label: "Home Health Prescriptions " },
    { value: "44", label: "Home Health Visits " },
    { value: "45", label: "Hospice " },
    { value: "47", label: "Hospital " },
    { value: "53", label: "Hospital - Ambulatory Surgical " },
    { value: "51", label: "Hospital - Emergency Accident " },
    { value: "52", label: "Hospital - Emergency Medical " },
    { value: "48", label: "Hospital - Inpatient " },
    { value: "50", label: "Hospital - Outpatient " },
    { value: "49", label: "Hospital - Room and Board " },
    { value: "80", label: "Immunizations " },
    { value: "61", label: "In-vitro Fertilization " },
    { value: "BA", label: "Independent Medical Evaluation " },
    { value: "83", label: "Infertility " },
    { value: "72", label: "Inhalation Therapy " },
    { value: "IC", label: "Intensive Care " },
    { value: "BS", label: "Invasive Procedures " },
    { value: "AO", label: "Lenses " },
    { value: "59", label: "Licensed Ambulance " },
    { value: "54", label: "Long Term Care " },
    { value: "BM", label: "Lymphatic " },
    { value: "62", label: "MRI/CAT Scan " },
    { value: "90", label: "Mail Order Prescription Drug " },
    { value: "BW", label: "Mail Order Prescription Drug: Brand Name " },
    { value: "BX", label: "Mail Order Prescription Drug: Generic " },
    { value: "55", label: "Major Medical " },
    { value: "CM", label: "Mammogram, High Risk Patient " },
    { value: "CN", label: "Mammogram, Low Risk Patient " },
    { value: "BE", label: "Massage Therapy " },
    { value: "69", label: "Maternity " },
    { value: "27", label: "Maxillofacial Prosthetics " },
    { value: "1", label: "Medical Care " },
    { value: "56", label: "Medically Related Transportation " },
    { value: "MH", label: "Mental Health " },
    { value: "CG", label: "Mental Health Facility - Inpatient " },
    { value: "CH", label: "Mental Health Facility - Outpatient " },
    { value: "CE", label: "Mental Health Provider - Inpatient " },
    { value: "CF", label: "Mental Health Provider - Outpatient " },
    { value: "NI", label: "Neonatal Intensive Care " },
    { value: "BQ", label: "Neurology " },
    { value: "65", label: "Newborn Care " },
    { value: "AQ", label: "Nonmedically Necessary Physical " },
    { value: "BI", label: "Nursery " },
    { value: "BU", label: "Obstetrical " },
    { value: "BV", label: "Obstetrical/Gynecological " },
    { value: "AD", label: "Occupational Therapy " },
    { value: "ON", label: "Oncology " },
    { value: "40", label: "Oral Surgery " },
    { value: "38", label: "Orthodontics " },
    { value: "BK", label: "Orthopedic " },
    { value: "9", label: "Other Medical " },
    { value: "77", label: "Otological Exam " },
    { value: "BB", label: "Partial Hospitalization (Psychiatric) " },
    { value: "66", label: "Pathology " },
    { value: "BH", label: "Pediatric " },
    { value: "24", label: "Periodontics " },
    { value: "88", label: "Pharmacy " },
    { value: "AE", label: "Physical Medicine " },
    { value: "PT", label: "Physical Therapy " },
    { value: "BY", label: "Physician Visit - Office: Sick " },
    { value: "BZ", label: "Physician Visit - Office: Well " },
    { value: "32", label: "Plan Waiting Period " },
    { value: "19", label: "Pneumonia Vaccine " },
    { value: "93", label: "Podiatry " },
    { value: "95", label: "Podiatry - Nursing Home Visits " },
    { value: "94", label: "Podiatry - Office Visits " },
    { value: "17", label: "Pre-Admission Testing " },
    { value: "74", label: "Private Duty Nursing " },
    { value: "CB", label: "Private Duty Nursing - Home " },
    { value: "CA", label: "Private Duty Nursing - Inpatient " },
    { value: "96", label: "Professional (Physician) " },
    { value: "A3", label: "Professional (Physician) Visit - Home " },
    { value: "99", label: "Professional (Physician) Visit - Inpatient " },
    { value: "A1", label: "Professional (Physician) Visit - Nursing Home " },
    { value: "98", label: "Professional (Physician) Visit - Office " },
    { value: "A0", label: "Professional (Physician) Visit - Outpatient " },
    {
      value: "A2",
      label: "Professional (Physician) Visit - Skilled Nursing Facility ",
    },
    { value: "75", label: "Prosthetic Device " },
    { value: "39", label: "Prosthodontics " },
    { value: "A4", label: "Psychiatric " },
    { value: "A7", label: "Psychiatric - Inpatient " },
    { value: "A8", label: "Psychiatric - Outpatient " },
    { value: "A5", label: "Psychiatric - Room and Board " },
    { value: "A6", label: "Psychotherapy " },
    { value: "PU", label: "Pulmonary " },
    { value: "BF", label: "Pulmonary Rehabilitation " },
    { value: "6", label: "Radiation Therapy " },
    { value: "A9", label: "Rehabilitation " },
    { value: "AB", label: "Rehabilitation - Inpatient " },
    { value: "AC", label: "Rehabilitation - Outpatient " },
    { value: "AA", label: "Rehabilitation - Room and Board " },
    { value: "RN", label: "Renal " },
    { value: "14", label: "Renal Supplies in the Home " },
    { value: "RT", label: "Residential Psychiatric Treatment " },
    { value: "46", label: "Respite Care " },
    { value: "25", label: "Restorative " },
    { value: "41", label: "Routine (Preventive) Dental " },
    { value: "AN", label: "Routine Exam " },
    { value: "81", label: "Routine Physical " },
    { value: "CK", label: "Screening X-ray " },
    { value: "CL", label: "Screening laboratory " },
    { value: "20", label: "Second Surgical Opinion " },
    { value: "AG", label: "Skilled Nursing Care " },
    { value: "AH", label: "Skilled Nursing Care - Room and Board " },
    { value: "BJ", label: "Skin " },
    { value: "67", label: "Smoking Cessation " },
    { value: "22", label: "Social Work " },
    { value: "AF", label: "Speech Therapy " },
    { value: "AI", label: "Substance Abuse " },
    { value: "CI", label: "Substance Abuse Facility - Inpatient " },
    { value: "CJ", label: "Substance Abuse Facility - Outpatient " },
    { value: "2", label: "Surgical " },
    { value: "8", label: "Surgical Assistance " },
    { value: "CD", label: "Surgical Benefits - Facility " },
    { value: "CC", label: "Surgical Benefits - Professional (Physician) " },
    { value: "21", label: "Third Surgical Opinion " },
    { value: "TC", label: "Transitional Care " },
    { value: "TN", label: "Transitional Nursery Care " },
    { value: "70", label: "Transplants " },
    { value: "UC", label: "Urgent Care " },
    { value: "11", label: "Used Durable Medical Equipment " },
    { value: "AL", label: "Vision (Optometry) " },
    { value: "68", label: "Well Baby Care " },
  ];
  const parseClaimMdResponse = (data) => {
    // 1️⃣ If rawResponse has XML error (root-level error)
    if (data?.rawResponse?.includes("<error")) {
      // Simple regex to extract error_code and error_mesg
      const codeMatch = data.rawResponse.match(/error_code="([^"]+)"/);
      const msgMatch = data.rawResponse.match(/error_mesg="([^"]+)"/);
      if (codeMatch && msgMatch) {
        return {
          status: "error",
          title: "Claim.MD Error",
          message: `[${codeMatch[1]}] ${msgMatch[1]}`,
        };
      }
    }

    // 2️⃣ If response explicitly says no eligibility data
    if (data?.success === false && data?.message) {
      return {
        status: "error",
        title: "No Eligibility Data",
        message: data.message,
      };
    }

    // 3️⃣ If eligibility object has errors
    if (data?.elig?.error?.length > 0) {
      return {
        status: "error",
        title: "Eligibility Error",
        message: data.elig.error
          .map((e, i) => `${i + 1}. [${e.error_code}] ${e.error_mesg}`)
          .join("\n"),
      };
    }

    // 4️⃣ Success case
    // if (data?.success === true || data?.elig?.eligid) {
    //   // rawResponse is XML like <result><elig eligid="200533359" ins_name_f="LORRIE" ins_name_l="ROLAND" ins_dob="19580426" ... /></result>
    //   const raw = data.rawResponse || "";
    //   const EligibilityId = data.eligibilityId;
    //   fetchEligibilityDetail(EligibilityId);
    //   // Extract eligid
    //   const eligidMatch = raw.match(/eligid="([^"]+)"/);
    //   const firstNameMatch = raw.match(/ins_name_f="([^"]+)"/);
    //   const lastNameMatch = raw.match(/ins_name_l="([^"]+)"/);
    //   const dobMatch = raw.match(/ins_dob="([^"]+)"/);

    //   return {
    //     status: "success",
    //     title: "Eligibility Verified",
    //     message:
    //       `Eligibility ID: ${
    //         eligidMatch ? eligidMatch[1] : data.eligibilityId || ""
    //       }\n` +
    //       `Subscriber: ${firstNameMatch ? firstNameMatch[1] : ""} ${
    //         lastNameMatch ? lastNameMatch[1] : ""
    //       }\n` +
    //       `DOB: ${dobMatch ? dobMatch[1] : ""}`,
    //   };
    // }
    if (data?.success === true || data?.elig?.eligid) {
      const EligibilityId = data.eligibilityId;
      fetchEligibilityDetail(EligibilityId);
      return null;
    }
    // 5️⃣ Fallback
    return {
      status: "error",
      title: "Unknown Response",
      message: "Unexpected response received from Claim.MD",
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setFormLoading(true);

    const formData = {
      // proc_code: procedureCode,
      ins_name_l:relationship ==="18" ? lastName : props.SubLastName,
      ins_name_f: relationship ==="18" ? firstName : props.SubfirstName,
      pat_name_l: lastName,
      pat_name_f: firstName,
      pat_rel: relationship ,
      ins_number: props.memberId,
      ins_dob: dob,
      fdos: dos,
      service_code: benefitType,
      patientId: props.patientId,
      planName: selectedInsurance.label,
      prov_npi: selectedProvider?.value?.trim(),
      prov_taxid: String(selectedProvider?.taxId).trim(),
      payerid: selectedInsurance.value,
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Eligibility/sendRequestClaimMd`,
        formData,
        { headers }
      );

      const parsed = await parseClaimMdResponse(response);
      if (!parsed) return;
      setFormLoading(false);
      await Swal.fire({
        icon: parsed.status,
        title: parsed.title,
        html:
          parsed.status === "error"
            ? `<ul style="text-align:left; font-size:12px; max-height:350px; overflow:auto; padding-left: 20px;">` +
              parsed.message
                .split("\n")
                .map((m) => `<li>${m}</li>`)
                .join("") +
              `</ul>`
            : `<pre style="text-align:left; max-height:350px;">${parsed.message}</pre>`,
        confirmButtonColor: parsed.status === "error" ? "#E74C3C" : "#356F60",
        width: 600,
        timer: parsed.status === "success" ? 1000 : undefined,
        showConfirmButton: parsed.status === "error",
        timerProgressBar: parsed.status === "success",
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });

      // // ✅ Only call handleCancel on success
      // if (parsed.status === "success") {
      //   props.handleCancel();
      // }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        html: `<pre style="text-align:left;">${error.message}</pre>`,
        confirmButtonColor: "#E74C3C",
        width: 600,
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });
      setFormLoading(false);
    } finally {
      setFormLoading(false);
    }
  };
  const [eligibilityDetail, setEligibilityDetail] = useState(null);
  const [benefits, setBenefits] = useState([]);
  const [detailLoading, setDetailLoading] = useState(false);
const getBenefitType = (item) => {
    const coverage = item.benefit_coverage_description?.toLowerCase() || "";
    const code = item.benefit_code;

    // ===== Deductible =====
    if (
      coverage.includes("out of pocket") ||
      coverage.includes("stop loss") ||
      coverage.includes("deductible") ||
      ["C", "29"].includes(code)
    ) {
      return "deductible";
    }

    // ===== Co-Insurance / Copayment (NEW) =====
    if (
      coverage.includes("co-insurance") ||
      coverage.includes("coinsurance") ||
      coverage.includes("copay") ||
      coverage.includes("co-pay") ||
      ["A", "B"].includes(code) // agar payer codes use karta ho
    ) {
      return "coinsurance";
    }

    // ===== Normal Benefits =====
    return "benefit";
  };

  const deductibleBenefits = benefits.filter(
    (b) => getBenefitType(b) === "deductible",
  );
  const patientBenefits = benefits.filter(
    (b) => getBenefitType(b) === "benefit",
  );
  const coInsuranceBenefits = benefits.filter(
    (b) => getBenefitType(b) === "coinsurance",
  );
  const getNetworkLabel = (value) => {
    if (value == "Y") return "In-Network";
    if (value == "N") return "Out-of-Network";
    if (value == "W") return "Conditional Network";
    return "Unknown";
  };
  // Determine Deductible Type
  const getDeductibleType = (item) => {
    const level = item.benefit_level_description || "";
    if (level.toLowerCase().includes("ind")) return "Individual";
    if (level.toLowerCase().includes("fam")) return "Family";
    return "Unknown";
  };

  // Deductible color based on type
  const getDeductibleColor = (item) => {
    const type = getDeductibleType(item);
    if (type === "Family") return "#f87171"; // Red
    if (type === "Individual") return "#d26c12"; // Yellow
    if (
      (item.benefit_coverage_description || "")
        .toLowerCase()
        .includes("out of pocket")
    )
      return "#3b82f6"; // Blue for OOP
    return "#d1d5db"; // Default gray
  };
  const fetchEligibilityDetail = async (eligibilityId) => {
    setDetailLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/Eligibility/getEligibility&BenfitsById?PatienteligibityId=${eligibilityId}`,
        { headers }
      );

      setEligibilityDetail(res);
      setBenefits(res?.patientBenefits || []);
    } catch (err) {
      console.error(err);
    } finally {
      setDetailLoading(false);
    }
  };
  const headerBg = eligibilityDetail
    ? "linear-gradient(135deg, #2fb9a5, #6fd3c6)" // Details
    : "linear-gradient(135deg, #1976d2, #42a5f5)"; // Request

  const handleBackClick = () => {
    if (eligibilityDetail) {
      setEligibilityDetail("");
    } else {
      props.handleCancel();
    }
  };

  return (
    <React.Fragment>
      <Headroom
        disable
        style={{
          margin: 0,
          padding: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            height: "64px",
            padding: "0 18px",
            background: headerBg,
            boxShadow: "0 3px 10px rgba(0,0,0,0.18)",
          }}
        >
          <ArrowBackOutlined
            fontSize="medium"
            onClick={handleBackClick}
            style={{
              color: "#f9ffff",
              cursor: "pointer",
              transition: "0.25s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = "#e0f2f1")}
            onMouseOut={(e) => (e.currentTarget.style.color = "#ffffff")}
          />

          {/* Title */}
          <DialogTitle
            style={{
              padding: 0,
              margin: 0,
              flex: 1,
              textAlign: "center",
            }}
          >
            <h1
              style={{
                margin: 0,
                fontWeight: 600,
                color: "#ffffff",
                fontSize: "1.35rem",
                letterSpacing: "0.6px",
              }}
            >
              {eligibilityDetail
                ? "Eligibility Details"
                : "Eligibility Request"}
            </h1>
          </DialogTitle>

          <CancelOutlinedIcon
            fontSize="medium"
            onClick={props.handleCancel}
            style={{
              color: "#f9ffff",
              cursor: "pointer",
              transition: "0.25s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = "#b71c1c")}
            onMouseOut={(e) => (e.currentTarget.style.color = "#f9ffff")}
          />
        </div>
      </Headroom>

      <form onSubmit={handleSubmit}>
        {!eligibilityDetail && (
          <Grid
            container
            spacing={1}
            sx={{
              border: "1px solid #d0d0d0",
              borderRadius: 2,
              p: 2,
              // width: "100%",
              // maxWidth: 900,
              backgroundColor: "#fafafa",
            }}
          >
            {/* Row 1: Patient Insurance / Insurance Company */}
            <Grid item xs={4} display="flex" justifyContent="space-between">
              <Box display="flex" flexDirection="column">
                <Typography variant="body2" color="textSecondary">
                  Patient Name
                </Typography>
                <Typography variant="body1" fontWeight={500} color="black">
                  {lastName}, {firstName}
                </Typography>
              </Box>
              <Box display="flex" flexDirection="column">
                <Typography variant="body2" color="textSecondary">
                  Patient's DOB
                </Typography>
                <Typography variant="body1" fontWeight={500} color="black">
                  {dob} {/* Format as needed */}
                </Typography>
              </Box>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
            <Grid item xs={3.65}>
              <Typography variant="body2" color="textSecondary">
                Insurance Company:
              </Typography>
              <TextField
                fullWidth
                size="small"
                placeholder="Search Insurance..."
                value={inputValue}
                onChange={(e) => handleSearch(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {loading ? (
                        <CircularProgress size={18} />
                      ) : (
                        <SearchIcon />
                      )}
                    </InputAdornment>
                  ),
                }}
                error={Boolean(errors.insurance)}
                helperText={errors.insurance}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: 2,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
              />

              {options.length > 0 && (
                <Paper
                  elevation={3}
                  sx={{
                    position: "absolute",
                    // width: "100%", // matches TextField
                    maxHeight: 220,
                    overflowY: "auto",
                    mt: 0.5,
                    zIndex: 1000,
                    borderRadius: 2,
                    boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                  }}
                >
                  <List dense>
                    {options.map((option, idx) => (
                      <React.Fragment key={option.value}>
                        <ListItem
                          button
                          sx={{
                            py: 1.2,
                            px: 2,
                            "&:hover": { backgroundColor: "#e3f2fd" },
                            cursor: "pointer",
                          }}
                          onClick={() => handleSelect(option)}
                        >
                          <span style={{ fontWeight: 500, color: "#344767" }}>
                            {option.value} –{" "}
                            {highlightMatch(option.label, inputValue)}
                          </span>
                        </ListItem>

                        {/* Divider between items except the last one */}
                        {idx < options.length - 1 && (
                          <div
                            style={{
                              height: 1,
                              backgroundColor: "#e0e0e0",
                              margin: "0 8px",
                            }}
                          />
                        )}
                      </React.Fragment>
                    ))}
                  </List>
                </Paper>
              )}
            </Grid>
            <Grid item xs={3.65}>
              <Typography variant="body2" color="textSecondary">
                Provider *
              </Typography>
              <Select
                // value={ProviderOption?.find(
                //   (option) => option.value == selectedProvider
                // )}
                value={selectedProvider}
                onChange={(option) => setSelectedProvider(option)}
                // onChange={(option) => setSelectedProvider(option.value)}
                options={ProviderOption}
                isSearchable
                size="small"
              />
              {errors.provider && (
                <Typography variant="caption" color="error">
                  {errors.provider}
                </Typography>
              )}
            </Grid>

            <Grid item xs={4} display="flex" justifyContent="space-between">
              <Box display="flex" flexDirection="column">
                <Typography variant="body2" color="textSecondary">
                  Member Id
                </Typography>
                <Typography variant="body1" fontWeight={500} color="black">
                  {policyNumber}
                </Typography>
              </Box>
              <Box display="flex" flexDirection="column">
                <Typography variant="body2" color="textSecondary">
                  Patient's Relation
                </Typography>
                <Typography variant="body1" fontWeight={500} color="black">
                  {props.SubfirstName ? 'Dependent':"Self"}
                </Typography>
              </Box>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
            <Grid item xs={3.65}>
              <Typography variant="body2" color="textSecondary">
                Benefit Type *
              </Typography>
              <Select
                value={eligibilityInfo?.find(
                  (option) => option.value == benefitType
                )}
                onChange={(option) => setBenefitType(option.value)}
                size="small"
                options={eligibilityInfo}
              />
              {errors.benefitTypee && (
                <Typography variant="caption" color="error">
                  {errors.benefitTypee}
                </Typography>
              )}
            </Grid>
            <Grid item xs={3.65}>
              {/* <Typography variant="body2" color="textSecondary">
                  Procedure Code *
                </Typography>
                <Select
                  value={ProcedureOption?.find(
                    (option) => option.value == procedureCode
                  )}
                  onChange={(option) => setProcedureCode(option.label)}
                  options={ProcedureOption}
                  isSearchable
                  size="small"
                /> */}
              <Typography variant="body2" color="textSecondary">
                Date of Service:
              </Typography>
              <TextField
                fullWidth
                type="date"
                size="small"
                value={dos}
                onChange={(e) => setDos(e.target.value)}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            {/* Row 3: To Date / Procedure Code */}
            <Grid item xs={4}>
              {props.SubLastName && (
                <>
               <Typography variant="body2" color="textSecondary">
                  Subscriber Name
                </Typography>
               <Typography variant="body1" fontWeight={500} color="black">
                  {props.SubLastName}, {props.SubfirstName}
                </Typography>
                </>
              )}
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
            {/* <Grid item xs={5.8}>
              <Typography variant="body2" color="textSecondary">
                Date of Service:
              </Typography>
              <TextField
                fullWidth
                type="date"
                size="small"
                value={dos}
                onChange={(e) => setDos(e.target.value)}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid> */}
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                  mt: 3,
                }}
              >
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={props.handleCancel}
                  size="large"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  sx={{ px: 4 }}
                  disabled={FormLoading}
                >
                  {/* Check Eligibility
                   */}
                  {FormLoading ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CircularProgress size={20} sx={{ color: "white" }} />
                      <Typography sx={{ color: "white", fontSize: 14 }}>
                        Loading...
                      </Typography>
                    </Box>
                  ) : (
                    "Check Eligibility"
                  )}
                </Button>
              </Box>
            </Grid>
          </Grid>
        )}
      </form>
      {eligibilityDetail && (
        <Grid
          container
          spacing={1}
          sx={{
            border: "1px solid #d0d0d0",
            borderRadius: 2,
            p: 3,
            // width: "100%",
            // maxWidth: 900,
            backgroundColor: "#fafafa",
          }}
        >
          {/* ================= ELIGIBILITY DETAILS ================= */}
          {detailLoading ? (
            <Box textAlign="center" p={2}>
              <CircularProgress />
            </Box>
          ) : (
            eligibilityDetail && (
              <Paper
                elevation={1}
                sx={{
                  p: 2,
                  borderRadius: "14px",
                  background: "#f9fafb",
                }}
              >
                <Typography
                  fontWeight={600}
                  mb={1}
                  sx={{
                    backgroundColor: "#e0f2f1",
                    color: "#004d40",
                    px: 1.5,
                    py: 0.5,
                    borderLeft: "4px solid #2fb9a5",
                    borderRadius: "4px",
                  }}
                >
                  Eligibility Details
                </Typography>

                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <b>Name:</b> {eligibilityDetail.ins_name_f}{" "}
                    {eligibilityDetail.ins_name_l}
                  </Grid>

                  <Grid item xs={4}>
                    <b>DOB:</b> {eligibilityDetail.eligibility_dob}
                  </Grid>

                  <Grid item xs={4}>
                    <b>Eligibility Date:</b>{" "}
                    {eligibilityDetail.eligibility_date}
                  </Grid>

                  <Grid item xs={4}>
                    <b>Gender:</b> {eligibilityDetail.ins_sex}
                  </Grid>

                  <Grid item xs={4}>
                    <b>Insurance #:</b> {eligibilityDetail.ins_number}
                  </Grid>

                  <Grid item xs={4}>
                    <b>Elig Id:</b> {eligibilityDetail.eligid}
                  </Grid>

                  <Grid item xs={4}>
                    <b>Zip:</b> {eligibilityDetail.ins_zip}
                  </Grid>

                  <Grid item xs={12}>
                    <b>Address:</b> {eligibilityDetail.ins_addr_1},{" "}
                    {eligibilityDetail.ins_city}
                  </Grid>
                </Grid>

               <Box>
            {/* ================= Deductibles ================= */}
            <Accordion
              sx={{
                borderRadius: "12px",
                mt: 1,
                backgroundColor: "#eef2ff",
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography fontSize="0.9rem" fontWeight={600}>
                  Deductibles
                </Typography>
              </AccordionSummary>
          
             <AccordionDetails sx={{ p: 1 }}>
            {deductibleBenefits.length === 0 ? (
              <Typography fontSize="0.85rem">No Deductibles Found</Typography>
            ) : (
              <Box>
                {deductibleBenefits.map((item, index) => (
                  <Paper
                    key={index}
                    elevation={1}
                    sx={{
                      mb: 0.75,
                      p: 1,
                      borderRadius: "10px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <Grid container spacing={0.5}>
                      {/* Colored Label for Deductible Type */}
                      <Grid item xs={12}>
                        <Typography
                          fontSize="0.8rem"
                          fontWeight={600}
                          sx={{
                            color: getDeductibleColor(item),
                            backgroundColor: "#f3f4f6",
                            px: 0.75,
                            py: 0.25,
                            borderRadius: "6px",
                            display: "inline-block",
                            mb: 0.5,
                          }}
                        >
                          {getDeductibleType(item)}{" "}
                          {item.benefit_coverage_description?.includes(
                            "Out of Pocket"
                          )
                            ? "(OOP Max)"
                            : "Deductible"}
                        </Typography>
                      </Grid>
          
                      {/* Network */}
                      <Grid item xs={6}>
                        <Typography fontSize="0.8rem" fontWeight={600}>
                          Network
                        </Typography>
                        <Typography fontSize="0.8rem">
                          {getNetworkLabel(item.inplan_network)}
                        </Typography>
                      </Grid>
          
                      {/* Amount / Met / Remaining */}
                      <Grid item xs={6}>
                        <Typography fontSize="0.8rem" fontWeight={600}>
                          Amount
                        </Typography>
                        <Typography fontSize="0.8rem">
                          ${item.benefit_amount.toLocaleString()} {/* You can add Met / Remaining if available */}
                        </Typography>
                      </Grid>
                    {item.benefit_description && (
                          <Grid item xs={12}>
                        <Typography fontSize="0.8rem" fontWeight={600}>
                          Service
                        </Typography>
                        <Typography fontSize="0.8rem">
                          {item.benefit_description}
                        </Typography>
                      </Grid>
                    )}
          
                      {/* ===== Commented out unnecessary info ===== */}
                      {/*
                      {item.benefit_coverage_description && (
                        <Grid item xs={12}>
                          <Typography fontSize="0.8rem" fontWeight={600}>
                            Benefit Description
                          </Typography>
                          <Typography fontSize="0.8rem">
                            {item.benefit_coverage_description}
                          </Typography>
                        </Grid>
                      )}
          
                      {item.benefit_description && (
                        <Grid item xs={6}>
                          <Typography fontSize="0.8rem" fontWeight={600}>
                            Type
                          </Typography>
                          <Typography fontSize="0.8rem">
                            {item.benefit_description}
                          </Typography>
                        </Grid>
                      )}
          
                      {item.benefit_period_description && (
                        <Grid item xs={6}>
                          <Typography fontSize="0.8rem" fontWeight={600}>
                            Applies Per
                          </Typography>
                          <Typography fontSize="0.8rem">
                            {item.benefit_period_description}
                          </Typography>
                        </Grid>
                      )}
          
                      {item.insurance_type_description && (
                        <Grid item xs={6}>
                          <Typography fontSize="0.8rem" fontWeight={600}>
                            Plan Type
                          </Typography>
                          <Typography fontSize="0.8rem">
                            {item.insurance_type_description}
                          </Typography>
                        </Grid>
                      )}
                      */}
                    </Grid>
                  </Paper>
                ))}
              </Box>
            )}
          </AccordionDetails>
          
            </Accordion>
          
            {/* ================= Patient Benefits ================= */}
            <Accordion
              sx={{
                borderRadius: "12px",
                backgroundColor: "#fff7ed",
                mt: 1,
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography fontSize="0.9rem" fontWeight={600}>
                  Benefits
                </Typography>
              </AccordionSummary>
          
              <AccordionDetails sx={{ p: 1 }}>
                {patientBenefits.length === 0 ? (
                  <Typography fontSize="0.85rem">No Benefits Found</Typography>
                ) : (
                  <Box>
                    {patientBenefits.map((item, index) => (
                      <Paper
                        key={index}
                        elevation={1}
                        sx={{
                          mb: 0.75,
                          p: 1,
                          borderRadius: "10px",
                          backgroundColor: "#f9fafb",
                          border: "1px solid #e5e7eb",
                        }}
                      >
                        <Grid container spacing={0.5}>
                          {/* Service */}
                          {item.benefit_description && (
                            <Grid item xs={12}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Service
                              </Typography>
                              <Typography fontSize="0.8rem">
                                {item.benefit_description}
                              </Typography>
                            </Grid>
                          )}
          
                          {/* Patient Responsibility */}
                          {item.benefit_coverage_description && (
                            <Grid item xs={6}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Coverage Description
                              </Typography>
                              <Typography fontSize="0.8rem">
                                {item.benefit_coverage_description}
                              </Typography>
                            </Grid>
                          )}
          
                          {/* Amount / Percent */}
                          {item.benefit_amount > 0 && (
                            <Grid item xs={6}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Amount You Pay
                              </Typography>
                              <Typography fontSize="0.8rem">
                                ${item.benefit_amount}
                              </Typography>
                            </Grid>
                          )}
          
                          {item.benefit_percent > 0 && (
                            <Grid item xs={6}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Percent You Pay
                              </Typography>
                              <Typography fontSize="0.8rem">
                                {item.benefit_percent}%
                              </Typography>
                            </Grid>
                          )}
          
                          {/* Period */}
                          {item.benefit_period_description && (
                            <Grid item xs={6}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Applies Per
                              </Typography>
                              <Typography fontSize="0.8rem">
                                {item.benefit_period_description}
                              </Typography>
                            </Grid>
                          )}
          
                          {/* Plan Type */}
                          {item.insurance_type_description && (
                            <Grid item xs={12}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Plan Type
                              </Typography>
                              <Typography fontSize="0.8rem">
                                {item.insurance_type_description}
                              </Typography>
                            </Grid>
                          )}
          
                          {/* Notes */}
                          {item.benefit_notes && (
                            <Grid item xs={12}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Additional Notes
                              </Typography>
                              <Typography fontSize="0.8rem">
                                {item.benefit_notes}
                              </Typography>
                            </Grid>
                          )}
                        </Grid>
                      </Paper>
                    ))}
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          
            {/* ================= Co-Insurance & Copayment ================= */}
            <Accordion
              sx={{
                borderRadius: "12px",
                mt: 1,
                backgroundColor: "#ecfeff",
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography fontSize="0.9rem" fontWeight={600}>
                  Co-Insurance & Copayment
                </Typography>
              </AccordionSummary>
          
              <AccordionDetails sx={{ p: 1 }}>
                {coInsuranceBenefits.length === 0 ? (
                  <Typography fontSize="0.85rem">
                    No Co-Insurance / Copayment Found
                  </Typography>
                ) : (
                  <Box>
                    {coInsuranceBenefits.map((item, index) => (
                      <Paper
                        key={index}
                        elevation={1}
                        sx={{
                          mb: 0.75,
                          p: 1,
                          borderRadius: "10px",
                          backgroundColor: "#ffffff",
                          border: "1px solid #bae6fd",
                        }}
                      >
                        <Grid container spacing={0.5}>
                          {/* Service */}
                          {item.benefit_description && (
                            <Grid item xs={6}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Service
                              </Typography>
                              <Typography fontSize="0.8rem">
                                {item.benefit_description}
                              </Typography>
                            </Grid>
                          )}
                          {item.inplan_network && (
                            <Grid item xs={6}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Network
                              </Typography>
                              <Typography fontSize="0.8rem">
                                {getNetworkLabel(item.inplan_network)}
                              </Typography>
                            </Grid>
                          )}
          
                          {/* Coverage Type */}
                          {item.benefit_coverage_description && (
                            <Grid item xs={6}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Type
                              </Typography>
                              <Typography fontSize="0.8rem">
                                {item.benefit_coverage_description}
                              </Typography>
                            </Grid>
                          )}
          
                          {item.benefit_amount > 0 && (
                            <Grid item xs={6}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Amount You Pay
                              </Typography>
                              <Typography fontSize="0.8rem">
                                ${item.benefit_amount}
                              </Typography>
                            </Grid>
                          )}
          
                          {item.benefit_percent > 0 && (
                            <Grid item xs={6}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Percent You Pay
                              </Typography>
                              <Typography fontSize="0.8rem">
                                {item.benefit_percent}%
                              </Typography>
                            </Grid>
                          )}
          
                          {/* Period */}
                          {item.benefit_period_description && (
                            <Grid item xs={6}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Applies Per
                              </Typography>
                              <Typography fontSize="0.8rem">
                                {item.benefit_period_description}
                              </Typography>
                            </Grid>
                          )}
          
                          {/* Plan Type */}
                          {item.insurance_type_description && (
                            <Grid item xs={12}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Plan Type
                              </Typography>
                              <Typography fontSize="0.8rem">
                                {item.insurance_type_description}
                              </Typography>
                            </Grid>
                          )}
          
                          {/* Notes */}
                          {item.benefit_notes && (
                            <Grid item xs={12}>
                              <Typography fontSize="0.8rem" fontWeight={600}>
                                Notes
                              </Typography>
                              <Typography fontSize="0.8rem">
                                {item.benefit_notes}
                              </Typography>
                            </Grid>
                          )}
                        </Grid>
                      </Paper>
                    ))}
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          </Box>
              </Paper>
            )
          )}
        </Grid>
      )}
    </React.Fragment>
  );
};

export default EligibilityCheck;
